import { Typography } from '@mui/material'
import { StoppageResponseEquipmentDto } from '@operations/app/api'
import { useTranslate } from '@tolgee/react'
import { computed } from 'mobx'
import { observer } from 'mobx-react-lite'

interface Props {
  equipments?: StoppageResponseEquipmentDto[]
  isVesselVisit?: boolean
  isForDashboard?: boolean
}
export const StoppageEquipments = observer(
  ({ equipments, isVesselVisit, isForDashboard }: Props) => {
    const { t } = useTranslate()

    const title = computed(() => {
      if (equipments?.length) {
        return equipments.map(e => e.name).join(', ')
      } else if (isVesselVisit) {
        return t('vessel', 'Vessel')
      } else {
        return t('train', 'Train')
      }
    }).get()

    return <Typography variant={isForDashboard ? 'body2' : 'subtitle2'}>{title}</Typography>
  },
)
